// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SocialLogin-displayFlexIcon-ikl_8 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    color: var(--secondary-oscuro) !important;
    font-size: clamp(16px, 1.2vw, 20px);
    font-family: var(--font-family-base);
    text-decoration: none !important;
}

.SocialLogin-displayFlexIcon-ikl_8:hover,
.SocialLogin-displayFlexIcon-ikl_8:focus {
    color: var(--secondary-oscuro) !important;
    text-decoration: none !important;
}

.SocialLogin-displayFlexIcon-ikl_8 img {
    width: 28px;
    height: 28px;
}

.SocialLogin-bgColor-jmm1y {
    background-color: rgba(255, 255, 255, 0.4);
    border: 1px solid var(--secondary-oscuro);
    border-radius: 19px;
    padding: 5px 18px;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    -webkit-transition: background-color 0.2s ease;
    transition: background-color 0.2s ease;
}

.SocialLogin-bgColor-jmm1y:hover {
    background-color: rgba(255, 255, 255, 0.8);
}`, "",{"version":3,"sources":["webpack://./src/components/SocialLogin/SocialLogin.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,yCAAyC;IACzC,mCAAmC;IACnC,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;IAEI,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,cAAc;IACd,8BAAsB;YAAtB,sBAAsB;IACtB,8CAAsC;IAAtC,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":[".displayFlexIcon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    color: var(--secondary-oscuro) !important;\n    font-size: clamp(16px, 1.2vw, 20px);\n    font-family: var(--font-family-base);\n    text-decoration: none !important;\n}\n\n.displayFlexIcon:hover,\n.displayFlexIcon:focus {\n    color: var(--secondary-oscuro) !important;\n    text-decoration: none !important;\n}\n\n.displayFlexIcon img {\n    width: 28px;\n    height: 28px;\n}\n\n.bgColor {\n    background-color: rgba(255, 255, 255, 0.4);\n    border: 1px solid var(--secondary-oscuro);\n    border-radius: 19px;\n    padding: 5px 18px;\n    width: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n    box-sizing: border-box;\n    transition: background-color 0.2s ease;\n}\n\n.bgColor:hover {\n    background-color: rgba(255, 255, 255, 0.8);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayFlexIcon": `SocialLogin-displayFlexIcon-ikl_8`,
	"bgColor": `SocialLogin-bgColor-jmm1y`
};
module.exports = ___CSS_LOADER_EXPORT___;
